import React, { useEffect, useState } from 'react';
import httpCommon from '../../../http-common';
import { CustomDataGrid } from '../../../common/components/Table/CustomDataGrid';
import CustomExportButton from '../../../common/components/Table/CustomExportButton';
import { Box, IconButton, Input, Switch } from '@mui/material';
import SnackbarWithMessage from '../../../common/components/Snackbars/SnackbarWithMessage';
import { FileUploaderRipik } from '../../HomePage/components/FileUploaderRipik';
import { v4 } from "uuid";
import { useGridApiRef } from '@mui/x-data-grid-pro';
import ContainedButton from '../../../common/components/Buttons/ContainedButton';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { mixpanelTrackTabsButton } from '../../../mixPanelFunctions/mixPanelFunctions';


const postAnalystDetails = async (form_data) => {
  try {
    const response = await httpCommon.post(`/v1/qc/analyst_details`, form_data);
    const result = response.data;
    if (result?.status === "success") return true;
    else throw new Error(`${result.message}`);
  } catch (error) {
    console.log({ error });
    return error;
    // return ;
  }
};

const deleteAnalystDetails = async (test_description_body) => {
  const data = JSON.stringify({ ...test_description_body });
  try {
    const response = await httpCommon.delete(`/v1/qc/analyst_details`, { data });
    const result = response.data;
    if (result?.status === "success") return true;
    else throw new Error(`Test Description couldn't be deleted, response message:${result.message}`);
  } catch (error) {
    console.log({ error });
    return error;
  }
};

const AnalystDetailsCell = ({ value, id, handle_change, type = "text" }) => {
  return <Input
    // sx={{ width: "100%" }}
    value={value}
    id={id}
    onChange={(e) => {
      handle_change(e);
    }}
    onKeyDown={(e) => {
      e.stopPropagation();
    }}
    type={type} />;
};

const AnalystDetails = () => {

  const apiRef = useGridApiRef();

  const [data, set_data] = useState([]);

  const fetch_analyst_data = async () => {
    const response = await httpCommon.get(`/v1/qc/analyst_details`);
    const result = (await response).data;
    console.log({ result });
    const data_for_data_grid = result.data.map(d => ({ ...d, id: d._id }));
    set_data([...data_for_data_grid]);
    return data_for_data_grid;
  };

  const handleDeleteTestDesscription = async (params) => {
    // console.log({ params });
    const {
      Analyst_id
    } = params.row;
    const response = await deleteAnalystDetails({
      analyst_id: Analyst_id
    });
    if (response === true) {
      const row_id = params.row.id;
      apiRef.current.updateRows([{
        id: row_id,
        // _action: "delete"
        is_disabled: !params?.row?.is_disabled
      }]);
    }
    else {
      console.log("probably this SLA doesn't exist, reloading the data for you.");
      fetch_analyst_data();
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      // width: 100
    }
    ,
    {
      field: "Analyst_id",
      headerName: "Analyst ID",
      // width: 100,
      editable: false,
      flex: 1,
    },
    {
      field: "analyst_name",
      headerName: "Analyst Name",
      // width: 100,
      flex: 1,
      editable: false,
    },
    {
      field: "Designation",
      headerName: "Designation",
      // width: 100,
      flex: 1,
      editable: false,
    },
    {
      field: 'is_disabled',
      headerName: 'Enable',
      width: 100,
      renderCell: (params) => {
        // console.log({ params });
        return (
          <Box style={{ position: 'sticky', right: 0, zIndex: 1 }}>
            <div style={{ width: "100%", display: "flex", justifyContent: "start" }} className='mr-auto'>
              <Switch
                className='mr-auto'
                checked={!params?.row?.is_disabled} onClick={() => {
                  handleDeleteTestDesscription(params);
                }} />
              {/* <IconButton onClick={() => handleDeleteTestDesscription(params)}>
                <DeleteIcon style={{ color: '#ff5722' }} />
              </IconButton> */}
            </div>
          </Box>
        );
      },
    },
  ];
  useEffect(() => {
    fetch_analyst_data();
  }, []);

  const [new_dg_row, set_new_dg_row] = useState([{
    id: v4(),
    "Analyst_id": "",
    "analyst_name": "",
    "Designation": "",
  }]);

  const handle_change_new_row_data = (e) => {
    const { id, value } = e.target;
    const old = { ...new_dg_row[0] };
    old[id] = value;
    set_new_dg_row([{ ...old }]);
  };

  const new_dg_columns = [
    {
      field: "Analyst_id",
      headerName: "Analyst Id",
      flex: 1,
      editable: false,
      renderCell: () => {
        return <AnalystDetailsCell value={new_dg_row[0]['Analyst_id']} handle_change={handle_change_new_row_data} id={"Analyst_id"} />;
      },
    },
    {
      field: "analyst_name",
      headerName: "Analyst Name",
      flex: 1,
      editable: false,
      renderCell: () => {
        return <AnalystDetailsCell value={new_dg_row[0]['analyst_name']} handle_change={handle_change_new_row_data} id={"analyst_name"} />;
      },
    },
    {
      field: "Designation",
      headerName: "Designation",
      flex: 1,
      editable: false,
      renderCell: () => {
        return <AnalystDetailsCell value={new_dg_row[0]['Designation']} handle_change={handle_change_new_row_data} id={"Designation"} />;
      },
    },
    {
      "field": "add_row",
      "headerName": "",
      "editable": false,
      renderCell: () => {
        const handle_add = async () => {
          const row = new_dg_row[0];
          const vals = Object.values(row);
          for (let val of vals) {
            if (val === "" || val === null) {
              alert("Please enter all the fields before adding the Analyst Details.");
              return;
            }
          }
          const {
            // id,
            Analyst_id,
            Designation,
            // ...rest
          } = row;
          // const sla_data = { analyst_id: Analyst_id, designation: Designation };
          const form_data = new FormData();
          form_data.append("analyst_id", Analyst_id);
          form_data.append("designation", Designation);
          const response = await postAnalystDetails(form_data);
          if (response === true) {
            // console.log(apiRef.current);
            apiRef.current.updateRows([{ ...row }]);
            set_new_dg_row(prev => ([{
              ...prev[0],
              id: v4(),
              Analyst_id: "",
              analyst_name: "",
              Designation: "",
            }]));
            // alert("updated");
          }
          else {
            // alert("couldn't update due to some error at the backend.");
            alert(response);
          }
        };
        return <ContainedButton handleClick={handle_add}>Add</ContainedButton>;
      }
    }
  ];

  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const [file, set_file] = useState(null);

  const handle_file_upload = async (uploaded_file) => {
    try {
      const data = new FormData();
      data.append("excel_file", uploaded_file);
      // console.log([...data.entries()]);
      const response = await httpCommon.post(`/v1/qc/upload_mastersheet/analyst_details/`, data, {
        "headers": {
          "Content-Type": "multipart/form-data"
        }
      });
      const result = response.data;
      mixpanelTrackTabsButton("AnalystDetails","file upload","master-sheet") // tracking tab button
      console.log({ result });
      if (result.status === "error") {
        set_open_snackbar_with_message({
          message: result.message,
          open: true,
          severity: "error"
        });
      }
      else if (result.status === "success") {
        set_open_snackbar_with_message({
          message: `Data uploaded successfully!`,
          open: true,
          severity: "success"
        });
        fetch_analyst_data();
      }
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <div>
      <Box>
        <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
          set_open_snackbar_with_message({
            open: false,
            message: "",
            severity: "info"
          });
        }} />
        <Box className="flex justify-end items-center">
          <FileUploaderRipik file={file} file_update_function={(uploaded_file) => {
            set_file(uploaded_file);
            console.log(uploaded_file);
            handle_file_upload(uploaded_file);
          }} upload_message={`Upload File Here`} />
        </Box>
        <CustomDataGrid
          slots={{
            toolbar: CustomExportButton
          }}
          columns={columns}
          rows={data}
          sx={{
            height: "500px"
          }}
          columnVisibilityModel={{
            id: false,
            _id: false
          }}
          apiRef={apiRef}
        />
      </Box>
      <Box>
        <CustomDataGrid
          columns={new_dg_columns}
          rows={new_dg_row}
          hideFooter
          columnVisibilityModel={{
            id: false,
            _id: false,
          }}
        />
      </Box>
    </div>
  );
};

export default AnalystDetails;